<template>
  <div
    class="discard-changes"
    style="height: 0"
  >
    <div
      class="reveal"
      id="discardChangesModal"
      data-reveal
    >
      <div class="modal-container">
        <p class="confirm-header">{{ $t('warn.discard') }}</p>
      </div>
      <div class="row align-right nav_btn">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeAlertModal()"
        >{{ $t('action.cancel') }}</button>
        <button
          type="button"
          class="btn btn--orange"
          v-hkldreset
          @click="discardChanges()"
        >{{ $t('action.ok') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import { mapActions } from 'vuex'

export default {
  name: 'DiscardChanges',

  methods: {
    ...mapActions('tenders', [
      'refreshTender',
    ]),
    async init (folderId) {
      if (!this.alertModal) {
        this.alertModal = await new Foundation.Reveal($('#discardChangesModal'), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      this.openAlertModal()
    },
    openAlertModal () {
      this.alertModal.open()
    },
    closeAlertModal () {
      this.alertModal.close()
    },
    discardChanges () {
      this.refreshTender()
      this.closeAlertModal()
      EventBus.$emit('modules_tenders_working_hours_clear')
    },
  },

  destroyed () {
    if (this.alertModal) {
      this.alertModal.destroy()
      delete this.alertModal
      $('#discardChangesModal').remove()
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
#discardChangesModal {
  align-self: baseline;
  width: 500px;
  font-weight: bold;
}
#discardChangesModal .confirm-header {
  margin-bottom: 0;
  font-size: 14px;
}
</style>
